import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const CenteredLogo = () => {
  return (
    <motion.div
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: 0.1 }}
      className="hidden md:flex justify-center pt-24 pb-8"
    >
      <Link to="/" className="group">
        <motion.img
          whileHover={{ scale: 1.05 }}
          src="/logo.png"
          alt="SimplyGods"
          className="h-32 w-auto object-contain transition-all duration-300 group-hover:drop-shadow-[0_0_25px_rgba(252,109,0,0.6)]"
        />
      </Link>
    </motion.div>
  );
};

export default CenteredLogo;
